//third party

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "../../components/components.module";
import { MaterialModule } from "../../material.module";

import { MissedCallsReportComponent } from "./missed-calls-report.component";

import { TotalMissedCallsComponent } from "./components/total-missed-calls/total-missed-calls.component";
import { MissedCallsByUserComponent } from "./components/missed-calls-by-user/missed-calls-by-user.component";
import { MissedCallsByGroupComponent } from "./components/missed-calls-by-group/missed-calls-by-group.component";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { CalendarModule } from "primeng/calendar";
import { DirectivesModule } from "../../directives/directives.module";

@NgModule({
  exports: [
    MissedCallsReportComponent,

    TotalMissedCallsComponent,
    MissedCallsByGroupComponent,
    MissedCallsByUserComponent,

    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ComponentsModule,
  ],
  declarations: [
    MissedCallsReportComponent,

    TotalMissedCallsComponent,
    MissedCallsByGroupComponent,
    MissedCallsByUserComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CalendarModule,
    NgxMaterialTimepickerModule,

    ComponentsModule,
    DirectivesModule
  ]
})
export class MissedCallsReportModule { }
